import React from 'react';

interface StarBorderProps {
  children: React.ReactNode;
  className?: string;
  color?: string;
  speed?: string;
  as?: string;
}

const StarBorder: React.FC<StarBorderProps> = ({
  children,
  className = '',
  color = '#667eea',
  speed = '4s',
  as: Tag = 'span',
}) => {
  return React.createElement(
    Tag as string,
    {
      className: `relative inline-block rounded-lg overflow-hidden star-border-wrapper ${className}`,
    },
    <>
      {/* Spinning conic border */}
      <span
        className="star-border-spin absolute inset-0 rounded-[inherit]"
        style={
          {
            '--star-color': color,
            '--star-speed': speed,
          } as React.CSSProperties
        }
      />
      {/* Inner content */}
      <span className="relative z-10 flex items-center px-2.5 py-1.5 rounded-[calc(theme(borderRadius.lg)-1px)] bg-dark-900/80 backdrop-blur-sm">
        {children}
      </span>
    </>
  );
};

export default StarBorder;
